<template>
	<section class="review-keywords">
		<!--연관 단어 등록 모달: 시작-->
		<div
			v-if="showAddRelatedWordModal"
			class="review-keywords__add-word-container"
		>
			<div class="review-keywords__add-word-wrapper">
				<h1 class="review-keywords__h1">연관 단어 등록</h1>
				<div>
					<label>
						<input v-model="inputRelatedWord" type="text" />
					</label>
					<div class="review-keywords__button-wrapper">
						<button class="btn blue" @click="addRelatedWord">
							추가
						</button>
						<button
							@click="inactiveAddRelatedWordModal"
							class="btn"
						>
							취소
						</button>
					</div>
				</div>
			</div>
		</div>
		<!--연관 단어 등록 모달: 끝-->

		<h1 class="review-keywords__h1">{{ categoryName }}</h1>
		<p class="review-keywords__p">
			{{
				moment(reviewKeywords.batchDate)
					.utc()
					.format('YYYY년 MM월 DD일 A HH:mm:ss')
			}}에 마지막 배치작업이 완료되었습니다.

			<button class="review-keyword__refresh-button btn" @click="refresh">
				<i
					class="fa fas fa-retweet review-keyword__refresh-button__i"
				></i>
				<span class="review-keyword__refresh-button__span"
					>새로고침</span
				>
			</button>
			<button
				:disabled="!reviewKeywords.isBatch"
				class="'review-keyword__mapping-button btn blue"
				:class="{
					'review-keyword__mapping-button--disabled':
						!reviewKeywords.isBatch,
				}"
				@click="mapping"
			>
				<i class="fa fas fa-link review-keyword__mapping-button__i"></i>
				<span class="review-keyword__mapping-button__span"
					>매핑하기</span
				>
			</button>
		</p>
		<div class="review-keywords__keywords-wrapper">
			<label
				class="review-keywords__keyword-label"
				v-for="keyword in reviewKeywords.keywords"
				:key="keyword.id"
			>
				<input
					class="review-keywords__keyword"
					type="text"
					v-model="keyword.name"
				/>
			</label>
		</div>
		<div
			class="review-keywords__keyword__related-words-wrapper"
			v-for="(keyword, indexKeyword) in relatedKeywords"
			:key="keyword.id"
		>
			<div class="review-keywords__keyword__related-words">
				<div
					v-for="(word, indexRelatedWord) in keyword.words"
					:key="word.id"
					@click="selectRelatedWord(indexKeyword, indexRelatedWord)"
					class="review-keywords__keyword__related-word-wrapper"
					:class="{
						'review-keywords__keyword__related-word-wrapper--selected':
							selectedRelatedWord[indexKeyword] ===
							indexRelatedWord,
					}"
				>
					<p
						class="review-keywords__keyword__related-word"
						:class="{
							'review-keywords__keyword__related-word--not-mapped':
								!word.isMapping,
						}"
					>
						{{ word.name }} <br />
						({{ word.count }})
						<toggleswitch-box
							v-if="word.isMapping"
							@changingVal="toggleRelatedKeyword(word)"
							:checkSts="word.isActive"
							:checkObj="{ value: true }"
							:unCheckObj="{ value: false }"
							size="small"
						/>
					</p>
				</div>
			</div>
			<div class="review-keywords__button-wrapper">
				<button
					class="btn bordered"
					@click="activeAddRelatedWordModal(indexKeyword)"
				>
					등록
				</button>
				<button
					class="btn bordered"
					@click="deleteRelatedWord(indexKeyword)"
				>
					삭제
				</button>
			</div>
		</div>
	</section>
</template>
<script>
	import moment from 'moment';
	import ToggleswitchBox from '../../../components/ToggleswitchBox.vue';
	import _ from 'lodash';
	import Vue from 'vue';

	export default {
		name: 'CategoryModifyReviewKeywords',
		components: {
			ToggleswitchBox,
		},
		data() {
			return {
				categoryName:
					this.$store.getters[
						'category/getSelectedCategoryNames'
					].join(' > '),
				reviewKeywords:
					this.$store.getters['category/getReviewKeywords'],
				inputRelatedWord: '',
				showAddRelatedWordModal: false,
				selectedKeyword: null,
				selectedRelatedWord: [null, null, null, null, null],
			};
		},
		computed: {
			relatedKeywords() {
				return _.each(this.reviewKeywords.keywords, keyword => {
					keyword.words = _.orderBy(
						keyword.words,
						['count'],
						['desc']
					);
				});
			},
		},
		methods: {
			moment,
			add() {
				let isEmpty = false;
				let isActive = true;

				_.each(this.relatedKeywords, keyword => {
					if (keyword.name.trim().length === 0) {
						isEmpty = true;
					}

					if (
						_.filter(keyword.words, { isActive: true }).length === 0
					) {
						isActive = false;
					}
				});

				if (isEmpty) {
					alert('키워드 5개를 모두 등록해주세요');
					this.$store.commit('toggleSpinner', false);
					return false;
				} else {
					this.$axios
						.put(
							`/lambda/admin/category/reviewKeyword/${this.reviewKeywords.category_id}`,
							[...this.reviewKeywords.keywords]
						)
						.then(res => {
							this.$store.commit(
								'category/refreshReviewKeywords',
								{
									values: this.reviewKeywords.keywords,
								}
							);

							if (!isActive) {
								this.$axios
									.put(
										`/lambda/admin/category/reviewKeyword/${this.reviewKeywords.category_id}/enabled`,
										{
											is_review_keyword: false,
										}
									)
									.then(res => {
										this.$store
											.dispatch(
												'category/changeIsReviewKeyword',
												true
											)
											.then(() => {});
									});
							}

							alert('변경사항이 저장되었습니다.');

							this.$store.commit('modal/toggleModal', false);

							this.$store.commit('toggleSpinner', false);
						})
						.catch(error => {
							console.error(error);
						});
				}
			},
			refresh() {
				this.$store.commit('toggleSpinner', true);

				const categoryId = this.reviewKeywords.category_id;

				setTimeout(() => {
					this.$axios
						.get(
							`/lambda/admin/category/reviewKeyword/${categoryId}`
						)
						.then(res => {
							this.$store.commit('category/setReviewKeywords', {
								data: res.data,
							});

							this.$store.commit('modal/toggleModal', false);

							setTimeout(() => {
								this.$store.commit('modal/toggleModal', {
									id: 'CategoryModifyReviewKeywords',
								});

								this.$store.commit('toggleSpinner', false);
							}, 300);
						});
				}, 1000);
			},
			mapping() {
				if (confirm('매핑을 수동으로 진행하시겠습니까?')) {
					this.$store.commit('toggleSpinner', true);

					this.$axios
						.post(`/lambda/admin/category/reviewKeyword/mapping`)
						.then(res => {
							this.refresh();
						})
						.catch(err => {
							if (err.response.status === 530) {
								alert(err.response.data.message);
							}

							this.$store.commit('toggleSpinner', false);
						});
				}
			},
			selectRelatedWord(indexKeyword, indexRelatedWord) {
				Vue.set(
					this.selectedRelatedWord,
					indexKeyword,
					indexRelatedWord
				);
			},
			deleteRelatedWord(indexKeyword) {
				if (this.selectedRelatedWord[indexKeyword] === null) {
					return false;
				}

				if (confirm('정말 삭제하시겠습니까?')) {
					this.reviewKeywords.keywords[indexKeyword].words.splice(
						this.selectedRelatedWord[indexKeyword],
						1
					);
					Vue.set(this.selectedRelatedWord, indexKeyword, null);
				}
			},
			toggleRelatedKeyword(word) {
				word.isActive = !word.isActive;
			},
			activeAddRelatedWordModal(keywordIndex) {
				this.showAddRelatedWordModal = true;
				this.selectedKeyword = keywordIndex;
			},
			inactiveAddRelatedWordModal() {
				this.showAddRelatedWordModal = false;
			},
			addRelatedWord() {
				const relatedWordArray = this.inputRelatedWord.split(',');
				const resultArray = [];

				_.each(relatedWordArray, word => {
					resultArray.push({
						is_active: false,
						is_mapping: false,
						name: word.trim(),
					});
				});

				this.reviewKeywords.keywords[this.selectedKeyword].words =
					_.uniqBy(
						[
							...this.reviewKeywords.keywords[
								this.selectedKeyword
							].words,
							...resultArray,
						],
						word => word.name
					);

				this.showAddRelatedWordModal = false;
				this.inputRelatedWord = '';
			},
		},
	};
</script>
<style lang="scss" scoped>
	.review-keywords__add-word-container {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background: rgba(10, 10, 10, 0.86);
		z-index: 9;
	}

	.review-keywords__add-word-wrapper {
		position: absolute;
		width: 90%;
		height: 25%;
		padding: 1em;
		background: #fff;
		left: 50%;
		top: 50%;
		transform: translate3d(-50%, -50%, 0);
	}

	.toggleswitch-box {
		float: right;
		margin-top: -0.8em;
	}

	.review-keywords__h1 {
		padding: 1em 0;
		font-size: 1rem;
		font-weight: bold;
	}

	.review-keywords__p {
		padding: 0 0 1em 0;
	}

	.review-keywords__keyword-label {
		position: relative;

		display: inline-block;
		width: 18%;
		margin-right: 2.5%;

		&:last-child {
			margin-right: 0;
		}
	}

	.review-keyword__refresh-button,
	.review-keyword__mapping-button {
		vertical-align: baseline;
	}

	.review-keyword__mapping-button--disabled {
		cursor: not-allowed;
		opacity: 0.3;
	}

	.review-keyword__refresh-button__i,
	.review-keyword__mapping-button__i {
		vertical-align: baseline;
	}

	.review-keywords__keyword {
		width: 100%;
		text-align: center;
	}

	.review-keywords__keyword__related-words-wrapper {
		position: relative;
		display: inline-block;
		width: 18%;
		vertical-align: top;
		margin-right: 2.5%;
		margin-top: 2.5%;

		&:last-child {
			margin-right: 0;
		}
	}

	.review-keywords__keyword__related-words {
		padding: 0.5em;
		border: 1px solid #dfe6ee;
		border-radius: 4px;
		min-height: 172px;
		max-height: 172px;
		overflow: auto;
	}

	.review-keywords__keyword__related-word-wrapper {
		padding: 0.5em 0;
		margin-bottom: 0.5em;
		cursor: pointer;
		transition: all 100ms ease-in-out;
	}

	.review-keywords__keyword__related-word-wrapper--selected {
		background-color: #f4f7fa;
		color: #657088;
		font-weight: bold;
	}

	.review-keywords__keyword__related-word--not-mapped {
		opacity: 0.5;
	}

	body {
		.btn {
			display: inline-block;
			padding: 0 12px;

			&.blue {
				border: solid 1px $btn-blue;
				color: #fff;
				background-color: $btn-blue;
			}
		}
	}

	.review-keywords__button-wrapper {
		padding-top: 1em;
		text-align: center;
	}
</style>
